<template>
    <div id="InspectionRecords">
        <AddRecord :dialogAdd="dialogAdd" @update="getSearchRecords"></AddRecord>
        <CheckRecord :dialogCheck="dialogCheck" :form="form"></CheckRecord>
        <el-row class="data_head">
            <el-col>
                <el-date-picker
                    v-model="dates"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
                <el-button type="primary" @click.native="search()" class="searchButton">查&nbsp;询</el-button>
                <el-button type="primary" @click="handleAdd()" class="searchButton">添&nbsp;加</el-button>
            </el-col>
        </el-row>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%" :header-cell-style="{background:'#335ABB',color:'#FFF'}"  stripe>
                <el-table-column align="center" prop="searchTime" label="巡查日期"></el-table-column>
                <el-table-column align="center" prop="position" label="部位"></el-table-column>
                <el-table-column align="center" prop="reason" label="病害类型"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleDelete(scope.row)" class="deleteButton">删&nbsp;除</el-button>
                        <el-button size="mini" type="primary" @click="handleCheck(scope.$index, scope.row)" class="checkButton">查&nbsp;看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body='false'>
            <span>删除不可恢复，是否确认删除</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="del">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import AddRecord from "./AddRecord";
import CheckRecord from "./CheckRecord";

export default {
    name: "InspectionRecords",
    components: {
        AddRecord,
        CheckRecord,
    },
    data() {
        return {
            dates: [],
            data: [],
            list: [],
            total: null,
            page: 1,
            pageSize: 10,
            delDialogVisible: false,
            dialogAdd: { show: false },
            dialogCheck: { show: false },
            form: {},
        };
    },
    mounted: function () {
        this.getSearchRecords();
    },
    methods: {
        getSearchRecords(){
            this.$axios.get('/api/monitor/SearchRecords/getSearchRecords').then(res => {
                if(res.data.status == 200){
                    this.list =  res.data.datas.values;
                }
                return
            })
        },
        search() {
            this.$axios.get(`/api/monitor/SearchRecords/getSearchRecords?
              startTime=${this.dates[0]}&endTime=${this.dates[1]}`).then((res) => {
                if(res.data.status == 200){
                   this.list =  res.data.datas.values;
                }
                return
                /*    this.total = res.data.data.page.totalNumber;
                this.data = res.data.data.page.content;
                this.list = this.data.filter((item,index) =>
                    index < this.page * this.pageSize && index >= this.pageSize * (this.page - 1)
                ); */
            });
        },
        handleAdd() {
            this.dialogAdd.show = true;
        },
        handleDelete(row) {
            this.delId = row.id;
            this.delDialogVisible = true;
        },
        del() {
            this.$axios.delete("/api/monitor/SearchRecords/deleteBySearchId", {params:{SearchId: this.delId}}).then((res) => {
                if(res.data.status == 200){
                    this.$message.success("删除成功");
                    this.delDialogVisible = false;
                    if(this.dates.length>1){
                        this.search(); // 把时间带进去
                    }else{
                        this.getSearchRecords()
                    }

                }
                return
            });
        },
        handleCheck(index,row) {
            this.form = {
                creatTime: row.creatTime,
                searchTime: row.searchTime,
                position: row.position,
                reason: row.reason,
                imageUrl: row.imageUrl,
                described : row.described,
            };
            this.dialogCheck.show = true;
        },
    },
};
</script>

<style>
    #InspectionRecords .el-table{
        color: #A7CCF6;
    }

    #InspectionRecords .el-table .info-warn {
        color: red;
    }

    #InspectionRecords .el-table__row {
        background-color: #0B3A68 !important;
    }

    #InspectionRecords .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #InspectionRecords .el-table td{
        border: unset;
    }

    #InspectionRecords .el-table th.is-leaf{
        border-bottom: none;
    }

    #InspectionRecords .el-date-editor--daterange.el-input__inner{
        background-color: #3457DE;
    }

    #InspectionRecords .el-date-editor .el-range-input{
        background-color: #3457DE;
        color: #FFF;
    }

    #InspectionRecords .el-date-editor .el-range-separator{
        background-color: unset;
        color: #FFF;
    }
</style>

<style scoped>
    @import url('../../assets/css/style.css');
    .deleteButton{
        background: #FB4D4B;
        border-color: #FB4D4B;
        color: #FFF;
    }
    .checkButton{
        background: #E68F02;
        border-color: #E68F02;
        color: #FFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/dataManage/inspection-records.vue